import { render, staticRenderFns } from "./ServicosOnline.vue?vue&type=template&id=364ba90e&lang=pug&"
import script from "./ServicosOnline.vue?vue&type=script&lnag=ts&lang=js&"
export * from "./ServicosOnline.vue?vue&type=script&lnag=ts&lang=js&"
import style0 from "./ServicosOnline.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports